import React, { useState } from "react";

const SearchForm = ({ searchFilter, clearSearchFilter, placeholderText }) => {
  const [searchText, setSearchText] = useState("");

  const onChangeText = (e) => {
    const text = e.target.value;
    setSearchText(text);
    if (text === "") {
      clearSearchFilter();
    } else {
      searchFilter(text);
    }
  };

  return (
    <div className="input-search-form form">
      <input
        type="search"
        name="interest-search"
        placeholder={placeholderText}
        value={searchText}
        onChange={onChangeText}
      />
    </div>
  );
};

export default SearchForm;
